import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src1878042246/src/nuxt/layouts/default.vue").then(m => m.default || m))
}